/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { InteractiveComponents } from '../../core/enums/InteractiveComponents';
import { ScreenTaskControllerTypes } from '../../core/navigation/ScreenTaskControllerTypes';
import {
    clearActiveInteractiveComponent,
    setActiveInteractiveComponent,
} from '../interactivelayer/interactiveLayer.reducers';
import { onKeyBackAudioTrackOverlay } from '../videoplayer/overlays/audiotrackoverlay/audiotrackoverlay.reducers';
import { onKeyBackErrorOverlay } from '../videoplayer/overlays/erroroverlay/erroroverlay.reducers';
import { onKeyBackSubtitleAndCCLanguageOverlay } from '../videoplayer/overlays/subtitleandcclanguageoverlay/subtitleandcclanguageoverlay.reducers';
import { setScreenTaskController } from '../screens/screens.reducers';
import { onKeyBackVideoPlayer } from '../videoplayer/navigation/videoplayernavigation.reducers';
import {
    onKeyBackFullInfoBanner,
    onMouseClickLeftFullInfoBanner,
    onMouseClickRightFullInfoBanner,
} from './infobanner/fullinfobannernavigation.reducers';
import { showTrickPlayMenu } from './infobanner/infobanner.reducers';
import { onKeyBackStandardInfoBanner } from './infobanner/standardinfobannernavigation.reducers';
import { onKeyBackTrickplayMenu } from './infobanner/trickplaymenunavigation.reducers';

export const onMouseClickRootInteractiveLayerOperations =
    () => (dispatch: Function, getState: Function) => {
        const { screenTaskController } = getState().screens;
        switch (screenTaskController) {
            case ScreenTaskControllerTypes.AUDIO_TRACK_OVERLAY:
                dispatch(onKeyBackAudioTrackOverlay());
                break;
            case ScreenTaskControllerTypes.FULL_INFO:
                dispatch(onKeyBackFullInfoBanner());
                break;
            case ScreenTaskControllerTypes.PLAYER_ERROR_OVERLAY:
                dispatch(onKeyBackErrorOverlay());
                dispatch(onKeyBackVideoPlayer());
                break;
            case ScreenTaskControllerTypes.STANDARD_INFO:
                dispatch(onKeyBackStandardInfoBanner());
                break;
            case ScreenTaskControllerTypes.SUBTITLE_AND_CC_LANGUAGE_OVERLAY:
                dispatch(onKeyBackSubtitleAndCCLanguageOverlay());
                break;
            case ScreenTaskControllerTypes.TRICKPLAY_MENU:
                dispatch(onKeyBackTrickplayMenu());
                break;
            default:
                dispatch(showTrickPlayMenu());
        }
    };

export const onMouseClickVideoPlayerUiInteractiveLayerOperations =
    () => (dispatch: Function, getState: Function) => {
        const { activeComponent } = getState().interactiveLayer;
        switch (activeComponent) {
            case InteractiveComponents.EAST:
                dispatch(onMouseClickRightFullInfoBanner());
                break;
            case InteractiveComponents.WEST:
                dispatch(onMouseClickLeftFullInfoBanner());
                break;
            default:
        }
    };

export const onMouseOutVideoPlayerUiOperations = () => (dispatch: Function, getState: Function) => {
    const { value } = getState().inputFactory;
    const { previousScreenTaskController } = getState().screens;
    switch (value) {
        case InteractiveComponents.EAST:
        case InteractiveComponents.WEST:
            dispatch(setScreenTaskController(previousScreenTaskController));
            dispatch(clearActiveInteractiveComponent());
            break;
        default:
    }
};

export const onMouseOverVideoPlayerUiOperations =
    () => (dispatch: Function, getState: Function) => {
        const { value } = getState().inputFactory;
        switch (value) {
            case InteractiveComponents.EAST:
            case InteractiveComponents.WEST:
                dispatch(setActiveInteractiveComponent(value));
                dispatch(
                    setScreenTaskController(
                        ScreenTaskControllerTypes.LIVE_TV_INTERACTIVE_LAYER_TASKS,
                    ),
                );
                break;
            default:
        }
    };
